/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_BodyInputs */

const en_not_found_body = /** @type {(inputs: Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for does not exist.`)
};

/**
* | output |
* | --- |
* | "The page you are looking for does not exist." |
*
* @param {Not_Found_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const not_found_body = /** @type {((inputs?: Not_Found_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_not_found_body(inputs)
});